exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".beer-handle,.beer-range:focus~.beer-handle{background-color:rgba(167,137,85,.95)}.beer-handle:after,.beer-handle:before{color:#fff}.beer-reveal{border-right:2px solid rgba(167,137,85,.95)}.beer-reveal:after,.beer-slider:after{color:#000}", ""]);

// exports
